import { useTranslation } from 'react-i18next';
import SearchAutocomplete from './SearchAutocomplete';

const ListSearchToolbar = ({
  searchInput,
  onSearchInputChange,
  onSearch,
  suggestions = [],
  suggestionsLoading = false,
  searchPlaceholder,
  filtersOpen,
  onToggleFilters,
  showFiltersToggle = true,
  children,
  className = '',
}) => {
  const { t } = useTranslation();

  return (
    <div className={`mb-4 space-y-3 ${className}`}>
      <div className="flex flex-wrap items-start gap-3">
        <SearchAutocomplete
          className="min-w-0 w-full flex-1 sm:min-w-[220px] sm:max-w-md"
          value={searchInput}
          onChange={onSearchInputChange}
          onSearch={onSearch}
          suggestions={suggestions}
          loading={suggestionsLoading}
          placeholder={searchPlaceholder}
        />
        {showFiltersToggle && onToggleFilters && (
          <button
            type="button"
            onClick={onToggleFilters}
            className="rounded-lg border border-zinc-300 dark:border-zinc-700 px-3 py-2 text-sm hover:bg-zinc-100 dark:hover:bg-zinc-800"
          >
            {filtersOpen ? t('common.hideFilters') : t('common.showFilters')}
          </button>
        )}
      </div>
      {filtersOpen && children && (
        <div className="flex flex-wrap items-end gap-3 rounded-xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900/50 p-3">
          {children}
        </div>
      )}
    </div>
  );
};

export default ListSearchToolbar;
